import mod from "-!./Times.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Times.js?vue&type=script&lang=js&"